import axios from 'axios'
const { BRANDID } = Config

// 装修API
export default class DecorationAPI {
  /** 获取装修方案信息和广告信息 */
  static async getDecorationCaseInfo (storeId?: number) {
    const url = `${ENV.JMOBILE}/mobileHomePage/getMobileTemplateAdvertV2`
    return axios.post(url, { brandId: BRANDID, storeId }).then((res: any) => {
      return res.result
    })
  }
}
